module.exports = __webpack_public_path__ + "static/media/r2.841f2730.jpeg";